import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const admin: Routes = [
  {
    path: 'soar-ai',
    children: [
      {
        path: '',
        loadComponent: () => import('./intro/intro-ai.component').then((m) => m.IntroAiComponent),
      },
      {
        path: 'chat',
        loadComponent: () => import('./chat/chat-ai.component').then((m) => m.ChatAiComponent),
      },
    ],
  },
];
  

@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class soarAiRoutingModule {
  static routes = admin;
}
